import { useEffect, useState } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import ChildComponent from "../../../components/applicationComponents/child/ChildComponent";
import SupportRequestedComponent from "../../../components/applicationComponents/supportRequested/SupportRequestedComponent";
import GroupInformationComponent from "../../../components/applicationComponents/groupInformation/groupInformationComponent";
import ProvidingInclusiveKindergartenEnvironmentComponent from "../../../components/applicationComponents/providingInclusiveKindergartenEnvironment/ProvidingInclusiveKindergartenEnvironmentComponent";
import KindergartenComponent from "../../../components/applicationComponents/kindergartenComponent/KindergartenComponent";
import ApplicationCreationComponent from "../../../components/applicationComponents/applicationCreation/ApplicationCreationComponent";
import ScreeningQuestionsComponent from "../../../components/applicationComponents/screeningQuestions/ScreeningQuestionsComponent";
import SubmitInitialApplicationComponent from "../../../components/applicationComponents/submitInitialApplication/SubmitInitialApplicationComponent";
import ChildAttendanceComponent from "../../../components/applicationComponents/childAttendance/ChildAttendanceComponent";
import ContextOfChildComponent from "../../../components/applicationComponents/contextOfChild/ContextOfChildComponent";
import ApplicationTypeComponent from "../../../components/applicationComponents/applicationType/ApplicationTypeComponent";
import SupportingDocumentsComponent from "../../../components/applicationComponents/supportingDocuments/SupportingDocumentsComponent";
import AppealRequestComponent from "../../../components/applicationComponents/appealRequest/AppealRequestComponent";

export default function KindergartenApplicationView() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText, applicationBase, rehydrate } = useApplicationContext();

  useEffect(() => {
    setHeaderText({
      value: "View Application",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-col align-items-start w-full height-calc">
          <ScreeningQuestionsComponent disabled={true} data={applicationBase.screeningQuestions} />
          <ApplicationCreationComponent disabled={true} />
          <SupportRequestedComponent disabled={true} data={applicationBase.supportRequested} />
          <KindergartenComponent disabled={true} data={applicationBase.kindergarten} />
          <GroupInformationComponent disabled={true} data={applicationBase.groupInformation} />
          <ProvidingInclusiveKindergartenEnvironmentComponent disabled={true} data={applicationBase.providingInclusiveKindergartenEnvironment} />
          <ChildComponent disabled={true} data={applicationBase.child} />
          <ChildAttendanceComponent disabled={true} data={applicationBase.childAttendance} />
          <ContextOfChildComponent disabled={true} data={applicationBase.contextOfChild} />
          <SupportingDocumentsComponent disabled={true} data={applicationBase.supportingDocuments} />
          {applicationBase.canKindergartenEdit && <SubmitInitialApplicationComponent disabled={true} />}
          <ApplicationTypeComponent disabled={true} data={applicationBase.applicationType} />
          <AppealRequestComponent disabled={true} data={applicationBase.appealRequest} />
        </div>
      )}
    </div>
  );
}
